/* eslint-disable */

// used to standardize height of location and prev visits
export const CHART_LAYOUT_BASE_ROW_HEIGHT = 225;
